import { render, staticRenderFns } from "./Spitalstellenmarkt.vue?vue&type=template&id=21e16cb0&scoped=true"
import script from "./Spitalstellenmarkt.vue?vue&type=script&lang=js"
export * from "./Spitalstellenmarkt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e16cb0",
  null
  
)

export default component.exports